import { render, staticRenderFns } from "./QTemplates.vue?vue&type=template&id=48a7a7ab&"
import script from "./QTemplates.vue?vue&type=script&lang=js&"
export * from "./QTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports